<template>
    <a :href="url" class="hover:text-primary-600 focus:outline-none transition ease-in-out duration-150 inline-flex items-center">
        <svg class="w-6 md:mr-1 -mt-1" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor"><path d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path></svg>
        <span class="hidden md:inline">({{ itemCount}})</span>
    </a>
</template>

<script>
	export default {
	    data() {
	        return {
	            itemCount: 0
            }
        },

		props: {
		    url: {
		        type: String,
                required: true,
            }
        },

        created() {
		    this.getItemCount();

		    bus.$on('update-basket-count', () => {
		        this.getItemCount();
            });
        },

        methods: {
	        getItemCount() {
	            axios.get('/basket/count')
                    .then(response => {
                        this.itemCount = response.data;
                    })
            }
        }
    }
</script>
